(ns frontend.domain.oppo.grid-settings
  (:require [frontend.state.current-session :as session]))

(defn ls-path
  [& rest]
  (concat
   [(:db/id @session/account)
    (:db/id @session/tenant)
    :deals-view-settings]
   rest))
